import React, { Component } from 'react'
import { Button, Col, Row, Label } from 'reactstrap'
import { IconeSetaSubir, IconeSetaDescer, IconeCarregar, IconeFileImport } from '../../comum/components/Icones'
import { observer, inject } from 'mobx-react'
import TabelasAcomp from './TabelasAcomp'
import Tooltip from '../../comum/components/Tooltip'

@inject("store")
@observer
export default class DetalhesAcomp extends Component {

    constructor(props){
        super(props)

        this.controller = this.props.controller
    }

    renderAvaria() {
        if(this.controller.tipoAcompanhamento !== "E"){
            if(this.controller.tipoAcompanhamento === "C" && process.env.rig){
                return null
            }else{
                return(
                    <div className="card-expansivel card-expansivel-tabela tabela-acomp-processo">
                        <div className="card">
                            <Row className={`titulo-booking align-items-center ${this.controller.avariaExpandido && 'login-form'}`}>
                                <Col>
                                    <div className="float-left card-expansivel--titulo col-md-3">Avaria</div>
                                    <div className="float-left text-sm-start col-md-9">
                                        Para visualizar o detalhamento da avaria realize o download do arquivo.
                                    </div>
                                </Col>
                                <Col>
                                    <div className="float-right" style={{display: 'flex', marginRight: '3px'}}>
                                        <Tooltip tooltipText='Adicionar BL e Packing'>
                                            <Button style={{marginRight: 10+"px"}} onClick={ () => this.controller.abrirModalArquivos() } outline className="collapseItem" active={ false }>
                                                { this.controller.detalhesCarregandoArquivos ? <IconeCarregar tamanho="lg" /> : <IconeFileImport tamanho="lg" /> }
                                            </Button>
                                        </Tooltip>
                                        <Button onClick={ () => this.controller.abrirFecharDetalhe("avaria") } outline className="collapseItem" active={ false }>
                                            { this.controller.avariaExpandido ? <IconeSetaSubir tamanho="lg" /> : <IconeSetaDescer tamanho="lg" /> }
                                        </Button>
                                    </div>
                                </Col>
                            </Row>
                            { this.controller.avariaExpandido  &&
                                <React.Fragment>
                                    <TabelasAcomp
                                        keyField="ContainerId" 
                                        colunas = {this.controller.colunasAvaria}
                                        dados = {this.controller.dadosContainers}
                                        controller={this.controller}
                                        avaria = {true}
                                    />
                                    <div className="text-right">
                                        Para visualizar o detalhamento da avaria realize o download do arquivo.
                                    </div>
                                </React.Fragment>
                            }
                            
                        </div>
                    </div>
                )
            }
        }
    }

    renderNotaFiscal() {
        if(this.controller.tipoAcompanhamento !== "E" && !process.env.rig){
            return(
                <div className="card-expansivel card-expansivel-tabela tabela-acomp-processo">
                    <div className="card">
                        <Row className={`titulo-booking align-items-center ${this.controller.nfExpandido && 'login-form'}`}>
                            <Col>
                                <div className="card-expansivel--titulo">Notas fiscais emitidas - Faturamento</div>
                            </Col>
                            <Col>
                                <div className="float-right" style={{ marginRight: '3px' }}>
                                    <Button onClick={ () => this.controller.abrirFecharDetalhe("notaFiscal") } outline className="collapseItem" active={ false }>
                                        { this.controller.nfExpandido ? <IconeSetaSubir tamanho="lg" /> : <IconeSetaDescer tamanho="lg" /> }
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                        { this.controller.nfExpandido &&
                            <React.Fragment>
                                <TabelasAcomp
                                    mensagemNotaFiscal={true}
                                    keyField="DocId" 
                                    colunas = {this.controller.colunasNF}
                                    dados = {this.controller.dadosNF}
                                />
                            </React.Fragment>
                        }
                    </div>
                </div>
            )
        }
    }

    render() {
        return (
            <div>
                <Row className="align-items-center">
                    <Col>
                        <h2 className="d-flex align-items-center">
                            Detalhes do Processo
                            {
                                this.controller.desistencia && <Label className="situacao-btn desistencia-vistoria ml-2 mb-0">
                                    Desistência de vistoria confirmada
                                </Label>
                            }
                        </h2>
                    </Col>
                    <Col>
                        {!process.env.rig && (this.controller.divergenciaLacre && !this.controller.desistencia) && <Button
                            className="float-right btn-com-bordas-primary mt-0 ml-0 mr-0 mb-0"
                            onClick={() => this.controller.abrirDesistencia()}
                        >
                            Desistir da vistoria
                        </Button>}
                    </Col>
                </Row>
                {this.renderAvaria()}
                {<div className="card-expansivel card-expansivel-tabela tabela-acomp-processo">
                    <div className="card">
                        <Row className={`titulo-booking align-items-center ${this.controller.detalhesCntrExpandido && 'login-form'}`}>
                            <Col>
                                <div className="card-expansivel--titulo">{this.controller.tipoAcompanhamento !== "E" ? "Detalhes dos containers" : "Dados Containers"}</div>
                            </Col>
                            <Col>
                                <div className="float-right">
                                    <Button onClick={ () => this.controller.abrirFecharDetalhe("detalheContainer") } outline className="collapseItem" active={ false }>
                                        { this.controller.detalhesCntrExpandido ? <IconeSetaSubir tamanho="lg" /> : <IconeSetaDescer tamanho="lg" /> }
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                        { this.controller.detalhesCntrExpandido &&
                            <React.Fragment>
                                <TabelasAcomp
                                    keyField="DocId" 
                                    colunas = {this.controller.colunasCntr}
                                    dados = {this.controller.dadosContainers}
                                />
                            </React.Fragment>
                        }
                    </div>
                </div>}
                {this.renderNotaFiscal()}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/acompanhamento/components/DetalhesAcomp.js